import ContentCenter from "../../ui/ContentCenter";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useDrag, useDrop } from "react-dnd";
import { shuffle } from "lodash";
import Timer from "../../ui/Timer";

const StartingPositions = styled.div`
  position: relative;
  width: 100%;
  height: 100%;


  .i-1 {
    position: absolute;
    top: 65px;
    left: 85px;
  }
  .i-2 {
    position: absolute;
    top: 220px;
    left: 40px;
  }
  .i-3 {
    position: absolute;
    top: 280px;
    left: 100px;
  }
  .i-4 {
    position: absolute;
    right: 75px;
    top: 10px;
  }
  .i-5 {
    position: absolute;
    right: 40px;
    top: 90px;
  }
  .i-6 {
    position: absolute;
    right: 35px;
    top: 160px;
  }
  .i-7 {
    position: absolute;
    right: 5px;
    top: 250px;
  }
  .i-8 {
    position: absolute;
    left: 10px;
    top: 130px;
  }
  .i-9 {
    position: absolute;
    right: 110px;
    top: 290px;
  }
  .i-10 {
    position: absolute;
    top: 25px;
    left: 25px;
  }
`;

const TopLeftField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 80px;
  position: absolute;
  left: 30%;
  top: 15%;
  background-color: #fff5e6;
  border: 3px solid black;
  border-radius: 50px 0 0 0;
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: center;
`;

const TopRightField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 80px;
  position: absolute;
  left: 43.8%;
  top: 15%;
  background-color: #fff5e6;
  border: 3px solid black;
  border-radius: 0 50px 0 0;
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: center;
`;

const GameOverDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
  left: 0%;
  width: 100%;
  height: 100%;
  background: rgba(242, 205, 206, 0.9);
  font-size: 20px;
`;

const MiddleRightField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
  height: 75px;
  width: 80px;
  position: absolute;
  left: 43.8%;
  top: 35.8%;
  background-color: #fff5e6;
  border: 3px solid black;
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: center;
`;

const BottomLeftField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 80px;
  position: absolute;
  left: 30%;
  top: 57.5%;
  background-color: #fff5e6;
  border: 3px solid black;
  border-radius: 0 0 0 50px;
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: center;
`;

const BottomRightField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 80px;
  position: absolute;
  left: 43.8%;
  top: 57.5%;
  background-color: #fff5e6;
  border: 3px solid black;
  border-radius: 0 0 50px 0;
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: center;
`;

const GameOverScreen = () => {
  return (
    <GameOverDiv>
      <strong>Gute Arbeit!</strong>
      Sie konnten sich alle Felder erfolgreich merken.
      <br />
    </GameOverDiv>
  );
};

const ItemTypes = {
  a: "1",
  b: "2",
  c: "3",
  d: "4",
  e: "5",
  f: "6",
  g: "7",
  h: "8",
  i: "9",
  j: "10",
};

const DraggableItem = ({ index, item, wasDropped, score, setScore }: any) => {
  const type =
    index === 0
      ? ItemTypes.a
      : index === 1
      ? ItemTypes.b
      : index === 2
      ? ItemTypes.c
      : index === 3
      ? ItemTypes.d
      : index === 4
      ? ItemTypes.e
      : "";
  const ref: any = useRef(null);

  useEffect(() => {
    if (wasDropped) {
      ref.current.style.display = "none";
      setScore(score + 1);
    }
  }, [wasDropped]);

  const [{ isDragging }, drag] = useDrag(() => ({
    type,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      className={`i-${item.split("/onposition/")[1].split(".png")[0]}`}
      style={{
        opacity: wasDropped ? 0 : isDragging ? 0.5 : 1,
        cursor: "move",
      }}
    >
      <img ref={ref} src={item} width={60} height={60} />
    </div>
  );
};

const DropableField = ({
  x,
  y,
  type,
  items,
  setCorrectItems,
  correctItems,
}: any) => {
  const ref: any = useRef(null);
  const accept =
    type === 0
      ? ItemTypes.a
      : type === 1
      ? ItemTypes.b
      : type === 2
      ? ItemTypes.c
      : type === 3
      ? ItemTypes.d
      : type === 4
      ? ItemTypes.e
      : ItemTypes.f;
  const [{ isOver }, drop]: any = useDrop(
    () => ({
      accept,
      drop: () => {
        ref.current.style.backgroundImage = `url(${items[type]})`;
        setCorrectItems(items[type]);
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [x, y]
  );

  return (
    <>
      {type === 0 && (
        <div ref={drop}>
          <TopLeftField ref={ref}></TopLeftField>
        </div>
      )}
      {type === 1 && (
        <div ref={drop}>
          <TopRightField ref={ref} />
        </div>
      )}
      {type === 2 && (
        <div ref={drop}>
          <MiddleRightField ref={ref} />
        </div>
      )}
      {type === 3 && (
        <div ref={drop}>
          <BottomLeftField ref={ref} />
        </div>
      )}
      {type === 4 && (
        <div ref={drop}>
          <BottomRightField ref={ref} />
        </div>
      )}
    </>
  );
};

const Card = ({ items, setCorrectItems, correctItems }: any) => {
  return (
    <div>
      <DropableField
        type={0}
        items={items}
        correctItems={correctItems}
        setCorrectItems={setCorrectItems}
      />
      <DropableField
        type={1}
        items={items}
        correctItems={correctItems}
        setCorrectItems={setCorrectItems}
      />
      <DropableField
        type={2}
        items={items}
        correctItems={correctItems}
        setCorrectItems={setCorrectItems}
      />
      <DropableField
        type={3}
        items={items}
        correctItems={correctItems}
        setCorrectItems={setCorrectItems}
      />
      <DropableField
        type={4}
        items={items}
        correctItems={correctItems}
        setCorrectItems={setCorrectItems}
      />
    </div>
  );
};

const generateItems = (level: number) => {
  const numberOfItems = level === 1 ? 5 : level === 2 ? 8 : 10;
  let items = [];
  const offset = level === 1 ? Math.ceil(Math.random() * 4) + 1 : level === 2 ? Math.ceil(Math.random() * 2) + 1: 1
  for (let i = 0; i < numberOfItems; i++) {
    items[i] = `/onposition/${i + offset}.png`;
  }
  items = shuffle(items);
  return { items, sliced: items.slice(0, 5) };
};

const RandomCard = ({ items }: any) => {
  return (
    <>
      <TopLeftField>
        <img src={items[0]} width={60} height={60} />
      </TopLeftField>
      <TopRightField>
        <img src={items[1]} width={60} height={60} />
      </TopRightField>
      <MiddleRightField>
        <img src={items[2]} width={60} height={60} />
      </MiddleRightField>
      <BottomLeftField>
        <img src={items[3]} width={60} height={60} />
      </BottomLeftField>
      <BottomRightField>
        <img src={items[4]} width={60} height={60} />
      </BottomRightField>
    </>
  );
};

export default ({ restart, level, setGameOver, gameOver }: any) => {
  const [items, setItems]: any = useState([]);
  const [randomItems, setRandomItems]: any = useState([]);
  const [showRandomCard, setShowRandomCard] = useState(true);
  const [correctItems, setCorrectItems]: any = useState([]);
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(6000);

  const handleRestart = () => {
    setScore(0);
    setTime(6000);
    const items = generateItems(level);
    setItems(items.items);
    setRandomItems(items.sliced);
    setGameOver(false);
    setShowRandomCard(true);
    setCorrectItems([]);
  };
  useEffect(() => {
    handleRestart();
  }, [restart]);

  useEffect(() => {
    if (time > 0) {
      setTimeout(() => setTime(time - 1000), 1000);
    } else setShowRandomCard(false);
  }, [time]);

  useEffect(() => {
    if (score === 5) setGameOver(true);
  }, [score]);
  
  useEffect(() => {
    document.body.ondrop = function (event) {
      event.preventDefault();
  }
  
  })

  return (
    <ContentCenter style={{ height: "100%" }}>
      {gameOver && <GameOverScreen />}
      {showRandomCard ? (
        <>
          <RandomCard items={randomItems} />
          <Timer time={time} />
        </>
      ) : (
        <>
          <StartingPositions>
            {items.map((item: any, index: number) => {
              return (
                <DraggableItem
                  key={index}
                  index={index}
                  item={item}
                  wasDropped={correctItems.indexOf(item) >= 0}
                  setScore={setScore}
                  score={score}
                />
              );
            })}
          </StartingPositions>
          <Card
            items={items}
            correctItems={correctItems}
            setCorrectItems={setCorrectItems}
          />
        </>
      )}
    </ContentCenter>
  );
};
